import { useController } from 'react-hook-form';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation, Trans } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

function CardRegisterMRPCModal({
  show, handleClose, control, defaultValue,
}) {
  const { t } = useTranslation();
  // Integracion con React Hook Form
  const {
    field: { onChange, name, value },
    fieldState: { error },
  } = useController({
    name: 'acceptContract',
    control,
    rules: { required: true },
    defaultValue,
  });

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      contentClassName="border-0"
      size="lg"
    >
      <Modal.Header className="pt-3 pb-4 app-txt-granite border-0 shadow-none" closeButton>
        {/* <Modal.Title className="mx-auto">
          <p className="mb-0 app-txt-red">Aviso</p>
        </Modal.Title> */}
      </Modal.Header>
      <Modal.Body className="overflow-auto" style={{ height: '500px' }}>
        <p className="app-txt-granite-80-dark">
          <Trans i18nKey="M_R_P_C:TXT_GUEST_AGREEMENT" />
        </p>

        <p className="app-txt-granite-80-dark">
          <Trans i18nKey="M_R_P_C:TXT_REGISTRATION" />
        </p>

        <p className="app-txt-granite-80-dark">
          <Trans i18nKey="M_R_P_C:TXT_PAYMENT" />
        </p>

        <p className="app-txt-granite-80-dark">
          <Trans i18nKey="M_R_P_C:TXT_ACCOMMODATIONS" />
        </p>

        <p className="app-txt-granite-80-dark">
          <Trans i18nKey="M_R_P_C:TXT_FACILITIES" />
        </p>

        <p className="app-txt-granite-80-dark">
          <Trans i18nKey="M_R_P_C:TXT_POSSESSIONS" />
        </p>

        <p className="app-txt-granite-80-dark">
          <Trans i18nKey="M_R_P_C:TXT_LIABILITY" />
        </p>

        <p className="app-txt-granite-80-dark">
          <Trans i18nKey="M_R_P_C:TXT_BEHAVIOR" />
        </p>

        <p className="app-txt-granite-80-dark">
          <Trans i18nKey="M_R_P_C:TXT_CLAIMS" />
        </p>

        <p className="app-txt-granite-80-dark">
          <Trans i18nKey="M_R_P_C:TXT_AFETY_AND_SECURITY" />
        </p>
      </Modal.Body>
      <Modal.Footer className="border-0 mx-auto d-block">
        <Form.Check className="mb-3 mx-auto ps-3" type="checkbox" id="cardRegiter">
          <Form.Check.Label className="custom-input-checkbox">
            <Form.Check.Input
              checked={value}
              type="checkbox"
              onChange={onChange}
              // onBlur={handleOnBlur}
              name={name}
            />
            <span className="checkmark">
              <FontAwesomeIcon icon={faCheck} />
            </span>
            <span className="label-text">{t('TXT_BTN_ACCEPT')}</span>
          </Form.Check.Label>
        </Form.Check>
        <Button
          variant=""
          onClick={handleClose}
          disabled={!value}
          // className="app-bg-red text-white app-fw-segoe-bold py-2 px-4 rounded-3 btn-height"
          className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height border-0"
        >
          {t('TXT_BOTON_CONTINUE')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CardRegisterMRPCModal;
